import React, {Component, ReactElement} from 'react'
import PreformattedDiv from '../../../styledComponents/PreformattedDiv'
import {Messages} from '../../../Messages'
import {StyledSecondaryButton} from '../../../styledComponents/Button'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Nullable} from '../../../app/TypeHelpers'
import {WideMainContainer} from '../../../styledComponents/ContentsArea'
import styled from 'styled-components'
import NotInterestedIcon from '@mui/icons-material/NotInterested'
import {Colors} from '../../../styledComponents/Constants'
import {getQueryParameter} from '../../common/util/Natutil';
import {Box} from '@mui/material'
import {Location} from 'react-router-dom'
import withStyles from '@mui/styles/withStyles'

interface ResidentSystemErrorState {
    message?: string
    nonDisplayBackBtnFlag?: boolean
}

interface Props {
    location: Location<ResidentSystemErrorState>
}

interface State {
    message: string
}

class NatResidentSystemErrorPage extends Component<Props & ResidentPagePropsSet, State> {
    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)

        // デフォルトメッセージの設定
        let message = Messages.ESYCC0015.toString()
        const messageId: string = getQueryParameter('messageId', this.props.location.search);
        if (messageId && messageId in Messages) {
            const key = messageId as keyof typeof Messages;
            message = Messages[key].toString();
        } else if (this.props.location.state && this.props.location.state.message) {
            // 遷移元から指定されたメッセージがあれば、設定
            message = this.props.location.state.message
        }

        this.state = {
            message: message,
        }
    }

    render(): Nullable<ReactElement> {
        const nonDisplayBackBtnFlag = this.props.location.state?.nonDisplayBackBtnFlag ?? false

        return <>
            <ContentArea>
                <ErrorTitleArea>
                    <StyledNotInterestedIcon/>
                    <ErrorTitle>
                        アクセスしようとしたページは表示できませんでした。
                    </ErrorTitle>
                </ErrorTitleArea>
                <Box height={'32px'}/>
                <WhiteArea>
                    <PreformattedDiv>{this.state.message}</PreformattedDiv>
                </WhiteArea>
                {
                    !nonDisplayBackBtnFlag &&
                    <>
                        <Box height={'60px'}/>
                        <StyledSecondaryButton
                            onClick={() => this.props.navigate(
                                '/resident/login',
                            )}>
                            ログイン画面へ戻る
                        </StyledSecondaryButton>
                    </>
                }
            </ContentArea>
        </>
    }
}

export default createResidentPage(NatResidentSystemErrorPage)

const ContentArea = styled.div`
  margin: auto;
  padding: 15px 0;
  max-width: 738px;
`

const ErrorTitleArea = styled.div`
  display: flex;
  align-items: center;
`

const StyledNotInterestedIcon = withStyles({
    root: {
        fontSize: '48px',
        color: '#b0b0b0',
    },
})(NotInterestedIcon)

const ErrorTitle = styled.div`
  margin-left: 8px;
  font-size: 20px;
  font-weight: bold;
  color: ${Colors.AccentDark};
`

const WhiteArea = styled(WideMainContainer)`
  padding: 15px;
`
